import React from 'react';
import { Icon } from '@app/src/common/Icon';
import {
  Wrapper,
  TitleContent,
  PackageName,
  CategoryName,
  DescriptionContent,
  Announcement,
  Legend,
  CountAnnouncement,
  Count,
  Bold,
  Newspaper,
  Extracharge,
  CountExtracharge,
  ActionContent,
  DateExpiration,
  TextRed,
  ButtonPublish,
  IconExpandMore,
  TitleWrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  packageName: string;
  categoryName: string;
  newspaperDetail: any[];
  extrachargeDetail: any[];
  expirationDate: string;
  urlPosting: string;
}

export const CardPackage: React.FC<Props> = ({
  packageName,
  categoryName,
  newspaperDetail,
  extrachargeDetail,
  expirationDate,
  urlPosting
}) => {

  const handleClickPosting = () => {
    sessionStorage.removeItem('print');
    if (isClient) {
      window.location.href = urlPosting;
    }
  };

  return (
    <Wrapper>
      <TitleContent>
        <TitleWrapper>
          <PackageName>{packageName}</PackageName>
          <CategoryName>{categoryName}</CategoryName>
        </TitleWrapper>
        <IconExpandMore>
          <Icon data-name="icon-expand-more" fill="#000" width="16" height="16" />
        </IconExpandMore>
      </TitleContent>
      <DescriptionContent>
        <Announcement>
          <Legend>Libres/Totales</Legend>
          {
            newspaperDetail && newspaperDetail.map((item, index) => (
              <CountAnnouncement key={index}>
                <Count><Bold>{item.stock}</Bold>/{item.total} Avisos</Count>
                <Newspaper>{item.publication}</Newspaper>
              </CountAnnouncement>
            ))
          }
        </Announcement>
        <Extracharge>
          {
            extrachargeDetail && extrachargeDetail.map((extra, index) => (
              <CountExtracharge key={index}>
                <Bold>{extra.stock}</Bold>/{extra.total} {extra.name}
              </CountExtracharge>
            ))
          }
        </Extracharge>
      </DescriptionContent>
      <ActionContent>
        <DateExpiration>
          <TextRed>Vence: </TextRed>{expirationDate}
        </DateExpiration>
        <ButtonPublish onClick={handleClickPosting}>Publicar</ButtonPublish>
      </ActionContent>
    </Wrapper>
  )
};